import moment from 'moment';

export default class AgentPresence {
  occurredAt: string;

  constructor(param: { occurredAt?: string } = {}) {
    this.occurredAt = param.occurredAt || moment().toISOString();
  }
}
